<template>
	<div>
		<navigation-component></navigation-component>
		<div class="main-content" id="panel">
	  		<header-component></header-component>
            <div class="header pb-5 bg-gradient-lighter">
                <div class="container-fluid">
                    <div class="header-body">
                        <div class="row align-items-center py-5">
                            <div class="col-lg-4">
                                <!--nombre del curso-->
                                <div class="row align-items-center">
                                    <div class="col-auto">
                                        <!-- Avatar -->
                                        <a href="#" class="avatar rounded-circle">
                                            <img alt="icono" src="assets/img/icons/word_icon.png">
                                        </a>
                                    </div>
                                    <div class="col">
                                        <h4>Word 2016 core</h4>
                                        <!--curso con barra de progreso-->
                                        <div class="progress-info">
                                            <div class="progress-label">
                                                <span>AVANCE GENERAL:</span>
                                            </div>
                                            <div class="progress-percentage">
                                                <span>60%</span>
                                            </div>
                                        </div>
                                        <div class="progress">
                                            <div class="progress-bar bg-info" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" style="width: 60%;"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Page content -->
            <div class="container-fluid mt--6">
                <!-- Contenedor de Student Course -->
                <!-- Basic with card header -->
                <div class="card ">
                    <!-- Card header -->
                    <div class="card-header bg-gradient-default text-white">
                        <!-- Title -->
                        <button type="button" class="btn btn-outline-neutral btn-xs" v-for="(leccion, index) in courseLessons" :key="leccion.idLesson" @click.prevent="getExercises(leccion.idLesson, leccion.sLesson)" :id="'btn' + leccion.idLesson"><i class="fas fa-chalkboard"></i> L{{ index + 1}}</button>
                    </div>
                    <!-- Card body de lección 1-->
                    <div class="card-body bg-gradient-gray">
                        <!--título de la lección y porcentaje de avance-->
                        <div class="row" v-if="showLesson">
                            <div class="col-6"><span class="text-white">{{sLesson}}</span></div>
                            <div class="col-4 right--9">
                                <div class="progress-info">
                                    <div class="progress-label">
                                        <span class="text-white">Avance de lección</span>
                                    </div>
                                    <div class="progress-percentage">
                                        <span class="text-white">0%</span>
                                    </div>
                                </div>
                                <div class="progress">
                                    <div class="progress-bar bg-success" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>
                                </div>
                            </div>
                        </div>
                        <!--Nivel 1 proyecto 1-->
                        <div class="card bg-default text-white text-sm" v-if="showLesson">
                            <div class="row media align-items-center" v-for="(ejercicio, index) in lessonExercises" :key="ejercicio.idExercise">
                                <div class="col-sm-1 ml-2 mt-1" style="max-width:4%;">
                                    <a href="#" class="avatar avatar-xs rounded-circle" data-toggle="tooltip" data-original-title="En progreso">
                                        <img alt="Image placeholder" src="assets/img/icons/progreso.png">
                                    </a>
                                </div>
                                <div class="col-sm"><a href="#" class="text-white">{{ejercicio.sTopic}}</a></div>
                                <div class="col-sm">
                                    <span>
                                        <div class="media align-items-center">
                                            <a class="avatar avatar-xs rounded-circle mr-2">
                                                <img alt="" src="assets/img/icons/requerido.png">
                                            </a>
                                            <div class="media-body">
                                                <a href="#"><span class="name mb-0 text-white">Aprender</span></a>
                                            </div>
                                        </div>
                                    </span>
                                </div>
                                <div class="col-sm">
                                    <!--<span>
                                        <div class="media align-items-center">
                                            <a href="#" class="avatar avatar-xs rounded-circle mr-2">
                                                <img src="assets/img/icons/requerido.png">
                                            </a>
                                            <div class="media-body">
                                                <a href="#"><span class="name mb-0 text-white">Practicar</span></a>
                                            </div>
                                        </div>
                                    </span> -->
                                </div>
                                <div class="col-sm">
                                    <span>
                                        <a class="btn btn-sm btn-icon-only text-white" href="#" role="button" data-toggle="modal" alt="eBook" data-target="#exampleModal" aria-haspopup="true" aria-expanded="false">
                                            <i class="fas fa-book-open"></i>
                                        </a>
                                    </span>
                                    <a class="btn btn-sm btn-icon-only text-white" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i class="fas fa-map-signs"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
	  	</div>
	</div>
</template>

<script>
	import Vue from 'vue'
	import VueForm from "vue-form"
	import NavigationComponent from '@/components/NavigationComponent'
	import HeaderComponent from '@/components/HeaderComponent'
	import options from "../validations/validations.js";
	Vue.use(VueForm, options);
	export default {
		name: 'CourseIndex',
		components: {
			NavigationComponent, HeaderComponent
		},
		data() {
			return {
                hostname: '',
                courseLessons: [],
                lessonExercises: [],
                showLesson: false,
                sLesson: '',
			}
		},

		methods: {
			async getExercises(idLesson, sLesson) {
                this.courseLessons.forEach( element => {
                    $("#btn" + element.idLesson).removeClass('active')
                })
                this.openLoading()
                await axios.get(apiKS + `api/ejercicios-leccion?platform=${this.$route.query.platform}&idLesson=${idLesson}`, { headers })
                .then( (response) => {
                    Swal.close()
                    this.lessonExercises = response.data
                    this.showLesson = true
                    this.sLesson = sLesson
                    $("#btn" + idLesson).addClass('active')
                })
                .catch( error => {
                    this.catchError(error)
                })
            }
		},
		
		async mounted() {
			this.hostname = hostname
			if(!user) {
                await this.getUserApi()
                this.usuario = user
            }

            await this.getCourseLessons(this.$route.query.platform, this.$route.query.version)

		},
		beforeMount() {
            document.body.classList.remove('bg-mos1')
			if(hostname == 'bpo.etciberoamerica.com') {
				
			}
		}
	}
</script>
